import PlanUpdate from './PlanUpdate.vue'
export { PlanUpdate }
export default PlanUpdate
